module.exports = __webpack_public_path__ + "static/brandbox-pricingBG-basic-85207a902def44946cb17f6828866e23.png";